import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { CheckCircle2, AlertCircle, AlertTriangle, Info } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider duration={4000}>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start gap-3 w-full pr-2">
              {variant === 'success' && (
                <div className="h-7 w-7 rounded-lg bg-emerald-500/20 text-emerald-400 flex items-center justify-center flex-shrink-0 mt-0.5 border border-emerald-500/30">
                  <CheckCircle2 className="h-4 w-4" />
                </div>
              )}
              {variant === 'destructive' && (
                <div className="h-7 w-7 rounded-lg bg-rose-500/20 text-rose-400 flex items-center justify-center flex-shrink-0 mt-0.5 border border-rose-500/30">
                  <AlertCircle className="h-4 w-4" />
                </div>
              )}
              {variant === 'warning' && (
                <div className="h-7 w-7 rounded-lg bg-amber-500/20 text-amber-400 flex items-center justify-center flex-shrink-0 mt-0.5 border border-amber-500/30">
                  <AlertTriangle className="h-4 w-4" />
                </div>
              )}
              {variant === 'info' && (
                <div className="h-7 w-7 rounded-lg bg-sky-500/20 text-sky-400 flex items-center justify-center flex-shrink-0 mt-0.5 border border-sky-500/30">
                  <Info className="h-4 w-4" />
                </div>
              )}
              <div className="grid gap-0.5 min-w-0 flex-1">
                {title && <ToastTitle className="text-xs font-bold leading-snug">{title}</ToastTitle>}
                {description && (
                  <ToastDescription className="text-[11px] text-slate-300 leading-relaxed opacity-90">{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose className="text-slate-400 hover:text-white" />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
